class CountUpNumber {
  constructor(el) {
    const countUpEls = document.querySelectorAll(el);
    if (countUpEls.length > 0) {
      this.event(countUpEls);
    }
  }

  event(countUpEls) {
    countUpEls.forEach((item) => {
      const resultNumber = Number(item.dataset.result || 0);
      const durationTime = Number(item.dataset.duration || 800);
      const useComma = item.dataset.comma !== "false";

      gsap.to(item, {
        scrollTrigger: {
          trigger: item,
          start: "top 75%",
          end: "top center",
          once: true,
          onEnter: () => {
            this.countUp(resultNumber, item, durationTime, useComma);
          },
        },
      });
    });
  }

  formatNumber(number, useComma = true) {
    return useComma ? number.toLocaleString() : String(number);
  }

  countUp(resultNumber, resultElement, duration = 500, useComma = true) {
    if (!resultElement) return;

    let currentNumber = 0;
    const interval = 10;
    const step = resultNumber / (duration / interval);

    const counter = setInterval(() => {
      currentNumber += step;

      if (currentNumber >= resultNumber) {
        currentNumber = resultNumber;
        clearInterval(counter);
      }

      const displayNumber = Math.floor(currentNumber);
      resultElement.textContent = this.formatNumber(displayNumber, useComma);
    }, interval);
  }
}
